import { render, staticRenderFns } from "./BranchSelectionForm.vue?vue&type=template&id=4d40d3f0&scoped=true&"
import script from "./BranchSelectionForm.vue?vue&type=script&lang=js&"
export * from "./BranchSelectionForm.vue?vue&type=script&lang=js&"
import style0 from "./BranchSelectionForm.vue?vue&type=style&index=0&id=4d40d3f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40d3f0",
  null
  
)

export default component.exports